import type { IconNode } from '../types';

/**
 * @name goal-net
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAyMFY2YTIgMiAwIDAgMSAyLTJoMTZhMiAyIDAgMCAxIDIgMnYxNCIgLz4KICA8cGF0aCBkPSJNOCA4djEyIiAvPgogIDxwYXRoIGQ9Ik0xMiA4djEyIiAvPgogIDxwYXRoIGQ9Ik0xNiA4djEyIiAvPgogIDxwYXRoIGQ9Ik02IDEwaDEyIiAvPgogIDxwYXRoIGQ9Ik02IDE0aDEyIiAvPgogIDxwYXRoIGQ9Ik02IDE4aDEyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/goal-net
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const goalNet: IconNode = [
  ['path', { d: 'M2 20V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14', key: '1k0zsb' }],
  ['path', { d: 'M8 8v12', key: '1gg7y9' }],
  ['path', { d: 'M12 8v12', key: 'rrnztl' }],
  ['path', { d: 'M16 8v12', key: 'q9i5gd' }],
  ['path', { d: 'M6 10h12', key: '1hwodj' }],
  ['path', { d: 'M6 14h12', key: '4cwo0f' }],
  ['path', { d: 'M6 18h12', key: '9pbo8z' }],
];

export default goalNet;
